import React from 'react';
import { PaginationList } from '../styles';
import { PaginationItem, PlaceholderItem, usePaginationSlots, PLACEHOLDER_SLOT, PreviousButton, NextButton } from '../shared';

var Pagination = function Pagination(_ref) {
  var pageUrls = _ref.pageUrls,
      currentPage = _ref.currentPage,
      onChangePage = _ref.onChangePage,
      className = _ref.className,
      dataTest = _ref['data-test'];
  var numPages = pageUrls.length;
  var paginationSlots = usePaginationSlots(currentPage + 1, numPages);
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "pagination",
    className: className,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(PaginationList, {
    "data-test": "pagination"
  }, /*#__PURE__*/React.createElement(PreviousButton, {
    currentPage: currentPage,
    onChangePage: onChangePage,
    pageUrls: pageUrls
  }), paginationSlots.map(function (indicator, index) {
    return indicator === PLACEHOLDER_SLOT ? /*#__PURE__*/React.createElement(PlaceholderItem, {
      key: "placeholder-".concat(index)
    }, indicator) : /*#__PURE__*/React.createElement(PaginationItem, {
      key: indicator,
      onChangePage: onChangePage,
      pageUrl: pageUrls[indicator - 1],
      isActive: indicator - 1 === currentPage
    }, indicator);
  }), /*#__PURE__*/React.createElement(NextButton, {
    currentPage: currentPage,
    onChangePage: onChangePage,
    pageUrls: pageUrls
  })));
};

Pagination.displayName = 'Pagination';
export default Pagination;